import { DEFAULT_TABLE_COMPANY_BLACKLIST } from './default-table-company-blacklist';
import { DEFAULT_TABLE_COUNTRIES } from './default-table-countries';
import { DEFAULT_TABLE_INDUSTRIES } from './default-table-industries';

export interface DefaultTableConfig {
  name: string;
  key: string;
  description: string;
  columns: readonly string[];
  entries: readonly (readonly string[])[];
}

export const DEFAULT_TABLES: DefaultTableConfig[] = [
  {
    name: 'Countries',
    key: 'countries',
    description: 'List of countries',
    columns: DEFAULT_TABLE_COUNTRIES.columns,
    entries: DEFAULT_TABLE_COUNTRIES.entries,
  },
  {
    name: 'Industries',
    key: 'industries',
    description: 'List of industries',
    columns: DEFAULT_TABLE_INDUSTRIES.columns,
    entries: DEFAULT_TABLE_INDUSTRIES.entries,
  },
  {
    name: 'Company Blacklist',
    key: 'company_blacklist',
    description: 'List of blacklisted companies',
    columns: DEFAULT_TABLE_COMPANY_BLACKLIST.columns,
    entries: DEFAULT_TABLE_COMPANY_BLACKLIST.entries,
  },
];
